module.exports = __webpack_public_path__ + "static/media/eye.14705b6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/eye.svg
// module id = 183
// module chunks = 0